import React from 'react'

const Appointments = () => {
  return (
    <div>
      appointments
    </div>
  )
}

export default Appointments
